import { ChangeDetectorRef, Component, OnInit, SimpleChanges } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools/tools.service';


import { Location } from '@angular/common';
@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.css']
})
export class CreditsComponent implements OnInit {

  selectedTabIndex: any = 0;
  savedDataBanco: any = null;

  constructor(
    public tools: ToolsService,
    private ref: ChangeDetectorRef,
    public translate: TranslateService,
    private location: Location

  ) { }

  ngOnInit() {


    /*** Check  paiement ***/
    this.SuccessPayment();

    /*** Check si bancontact paiement***/
    // this.checkPaymentIntent();
  }


  ngOnChanges(changes: SimpleChanges): void {

  }




  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
  }




  changeTab($event?: any) {

    this.SuccessPayment();
  }

  changeTabStripe($event?: any) {

    this.SuccessPaymentStripe();
  }


  /**
   * @description success tout  paiement sauf bancontact et stripe element
   */
  SuccessPayment() {

    let payment = this.tools.getStor("payment_credit");
    this.selectedTabIndex = payment ? 1 : this.selectedTabIndex;
    this.tools.removeStor("payment_credit");
    this.ref.detectChanges();

  }

  /**
  * @description success tout  paiement sauf bancontact
  */
  SuccessPaymentStripe() {


    this.selectedTabIndex = 1

    this.ref.detectChanges();

  }






  /**
   * @description success paiement bancontact
   */

  SuccessPaymentBanco(data?: any) {

    this.selectedTabIndex = 1;
    this.ref.detectChanges();
  }




  /**
   * @description Vérifie si on vient d'une redirection apres un paiement bancontact
   */



  checkPaymentIntent(): void {

    const url = new URL(window.location.href);

    const clientSecret = url.searchParams.get('payment_intent_client_secret');
    const status = url.searchParams.get('redirect_status');
    const that = this;

    if (clientSecret) {


      /*** On récupère les données essentielles qui ont été sauvegardées avant la redirection vers le paiement  */
      let savedDataBanco = that.tools.getStor('payment_save_banco_credit');

      if (savedDataBanco) {

        /*** Si paiement accepté alors on redirige directement vers page success  */
        if (status === 'succeeded') {

          this.SuccessPaymentBanco(savedDataBanco);

        } else {


          /*** On affiche un message d'erreur de paiement */

          that.tools.openSnackBar(this.translate.instant('credit_due.error_pay'), 'warn', 10000);


          /*** On retourne */

          this.location.replaceState('home/credits');
          that.savedDataBanco = savedDataBanco.credit;


        }
      }

      that.tools.removeStor('payment_save_banco_credit');


    }


  }
}
